<template>
  <div class="login-background" style="background-size: 400% 400%;">
    <div class="row content-center">
      <div class="absolute-center">
        <div class="login-widget-card">
          <div class="-md column" style="max-width: 300px">
            <q-form
                @submit="authenticateUser"
                class="q-gutter-y-md"
            >
              <div class="text-primary text-h5 text-center">
                Панель управления
              </div>
              <q-input v-model="email" label="Логин">
                <template v-slot:append>
                  <q-icon name="ion-person" />
                </template>
              </q-input>
              <q-input type="password" v-model="password" label="Пароль">
                <template v-slot:append>
                  <q-icon name="ion-lock" />
                </template>
              </q-input>
              <q-btn  flat dense type="submit" style="width: 100%" label="Войти" />
            </q-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue";
import axios from "axios";
import {apiUrl} from "../config";

export default {
  name: "login",
  data() {
    return {
      email: ref(null),
      password: ref(null)
    }
  },
  methods: {
    authenticateUser() {
      // credentials
      const email = this.email;
      const password = this.password;
      console.log(email)
      axios
          .post(apiUrl + '/admin/login/', {}, {auth:{
              username: email,
              password: password
            }})
          .then(() => {
            this.$store.commit('updateCredentials', {
              username: email,
              password: password
            })
            this.emitter.emit('setAuthenticated');
          })
          .catch((error) => {
            console.log(error)
            this.email = null;
            this.password = null;
          })
    }
  }
}
</script>

<style scoped>

</style>